export default "__VITE_ASSET__0383afa1__"